import { parseJson } from 'src/lib/common';

export const prepareUser = ({ accounts, companyInformation, ...rest }) => {
  const user = {
    ...rest,
    companyInformation: parseJson(companyInformation),
  };

  // TODO: rework to using `accounts` field name instead of `customers`
  user.customers = accounts
    ? accounts.edges.map((edge) => ({
        role: edge.role,
        isInvited: edge.isInvited,
        ...edge.node,
      }))
    : [];

  return user;
};
